import styled from 'styled-components';

export const WrapperSelectable = styled.div`
  display: grid;
  place-items: center;
  width: 110px;
  padding: 30px 0 14px;
`;

export const WrapperInputShare = styled.div`
  display: grid;
  gap: 24px;
  margin-top: 16px;
`;

export const WrapperActionsShare = styled.div`
  display: flex;
  gap: 20px;
`;

export const WrapperSelectContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const ContainerShare = styled.div`
  display: grid;
  gap: 16px;
`;
